const defaultMapping = {
  'Indent Number': 'indent_no',
  'Material Unique Number': 'material_ref_id',
  'Material Code': 'material_code',
  Quantity: 'quantity',
  'Quantity Unit': 'quantity_unit',
  Weight: 'weight',
  'Weight Unit': 'weight_unit',
  Volume: 'volume',
  'Volume Unit': 'volume_unit',
  'Pickup Point': 'pickup_point',
  'Ship To': 'ship_to',
  'Sold To': 'sold_to',
  'Invoice Amount': 'invoice_amount',
  'Invoice Number': 'invoice_number',
  'Invoice Date': 'invoice_date',
  Mrp: 'mrp',
  Category: 'category',
};

const defaultPackageDetailMapping = {
  'Package code': 'package_id',
  'Package reference Id': 'package_ref_id',
  'Package Weight': 'package_weight',
  'Package Weight Unit': 'package_weight_unit',
  'Package Volume': 'package_volume',
  'Package Volume Unit': 'package_volume_unit',
  'Package Quantity': 'package_quantity',
  'Package Quantity Unit': 'package_quantity_unit',
  'Is Kit(Yes/No)': 'is_kit',
};

module.exports = { defaultMapping, defaultPackageDetailMapping };
